module.exports = __webpack_public_path__ + "img/loading.0729f8d5.svg";